/* USE .bd-slider class to initialize slider, do not add the .bd-slider class to thumbs using data-slider-thumbs=".class" will initialize the slider for the thumbnails - each slider needs to be wrapped in 
<bd-slider>
<div class="bd-slider">
<div class="bd-track">
<div (or any element) class=".slide">
*/
// @ts-nocheck
class bdSlider extends HTMLElement {
  constructor() {
    super();
    this._resizeHandler = this.handleResize.bind(this);
    this._paginationClick = false;
  }

  connectedCallback() {
    // Attach resize listener  once
    window.addEventListener('resize', this._resizeHandler);
    // Initialize slider
    this.initSlider();
  }
  initSlider() {
    this.slider = this.querySelector('.bd-slider');
    if (!this.slider) return;

    // Detect underflow BEFORE cloning or Embla init
    const underflow = this.hasUnderflow();
    this.slider.classList.toggle('is-underflow', underflow);

    this.handleWheel = this.handleWheel.bind(this);
    this.slider.addEventListener('wheel', this.handleWheel, { passive: false });

    const dataset = this.dataset;
    console.log(dataset);
    const disableSetting = dataset.sliderDisable;
    // Check breakpoint disable BEFORE initializing Embla
    if (disableSetting && this.isDisabledForViewport(disableSetting)) {
      this.destroySlider();
      return;
    }

    // Prevent double initialization
    // if (this.embla) return;
    const autoplayMs = dataset.autoplay ? parseInt(dataset.autoplay) : 0;
    const scrollSpeed = dataset.scrollSpeed
      ? parseFloat(dataset.scrollSpeed)
      : null;

    // --- MARQUEE DUPLICATION FIX (dynamic, ensures overflow) ---
    if (scrollSpeed) {
      const track = this.slider.querySelector('.bd-track');
      const slides = Array.from(track.children);

      if (!track.dataset.cloned) {
        const viewportWidth = this.slider.offsetWidth;
        let trackWidth = track.scrollWidth;

        // Only clone if track is smaller than viewport
        if (trackWidth < viewportWidth) {
          while (trackWidth < viewportWidth * 2) {
            slides.forEach((slide) => {
              const clone = slide.cloneNode(true);
              clone.classList.add('is-clone');
              track.appendChild(clone);
            });
            trackWidth = track.scrollWidth;
          }
        }

        track.dataset.cloned = 'true';
      }
    }

    const fadeMode = dataset.fade === 'true';
    const alignMode = dataset.align || 'start';
    const wantsCenter = alignMode === 'center';
    const dragFree = dataset.dragFree === 'true';
    const containScroll = dataset.containScroll || false;

    const speed = dataset.speed ? parseInt(dataset.speed) : 7;

    const options = {
      loop: dataset.wrapAround === 'true',
      align: alignMode,
      draggable: !fadeMode,
      dragFree: fadeMode ? false : dragFree,
      containScroll: fadeMode ? false : containScroll,
      speed: fadeMode ? 0 : speed,
      skipSnaps: false,
      inViewThreshold: 0.25,
      containerSelector: '.bd-track',
      slides: '.bd-track > :not(template)',
    };

    // Decide plugins based on scrollSpeed
    const plugins = [];
    if (scrollSpeed) {
      plugins.push(
        EmblaCarouselAutoScroll({
          speed: scrollSpeed,
          stopOnInteraction: false,
          target: 'snap',
        }),
      );
    }

    if (fadeMode) {
      plugins.push(EmblaCarouselFade());
    } else if (scrollSpeed) {
      plugins.push(
        EmblaCarouselAutoScroll({
          speed: scrollSpeed,
          stopOnInteraction: false,
          target: 'snap',
        }),
      );
    }

    // Initialize Embla
    this.embla = EmblaCarousel(this.slider, options, plugins);
    //console.log('Snap points:', this.embla.scrollSnapList());
    this.dispatchEvent(new CustomEvent('embla-ready', { bubbles: true }));
    // Initial Slide Start
    const initialSlide = parseInt(this.dataset.initialSlide);
    if (!isNaN(initialSlide)) {
      this.embla.scrollTo(initialSlide, true); // jump = true → no animation
    }

    this.updateControls = this.updateControls.bind(this);

    this.embla.on('init', this.updateControls);
    this.embla.on('reInit', this.updateControls);
    this.embla.on('resize', this.updateControls);

    this.setupThumbnails();

    // AutoScroll interaction management
    if (scrollSpeed) {
      const autoScroll = this.embla.plugins().autoScroll;
      const viewport = this.embla
        .rootNode()
        .querySelector('.bd-track').parentElement;

      const stopAuto = () => autoScroll.stop();
      viewport.addEventListener('pointerdown', stopAuto);
      viewport.addEventListener('mouseenter', stopAuto);
      viewport.addEventListener('mouseleave', () => {
        autoScroll.play({ jump: true });
      });
    }
    // Mode: Step‑by‑step autoplay
    if (!scrollSpeed && autoplayMs > 0) {
      this.startAutoplay(autoplayMs);
    }

    // Hide controls if only one slide
    if (this.embla.slideNodes().length <= 1) {
      this.querySelector('[data-prev]')?.classList.add('visually-hidden');
      this.querySelector('[data-next]')?.classList.add('visually-hidden');
      this.querySelector('.slider-dots')?.classList.add('visually-hidden');
    }

    this.setupDots();
    this.setupArrows();
    this.setupPrevNext();
    this.setupCustomPagination();
    requestAnimationFrame(() => this.updateControls());

    let edgeUpdateId;

    const updateEdges = () => {
      cancelAnimationFrame(edgeUpdateId);
      edgeUpdateId = requestAnimationFrame(() => this.markEdgeProximity());
    };

    this.embla.on('select', updateEdges);
    this.embla.on('scroll', updateEdges);
    updateEdges(); // initial run

    this.embla.on('pointerUp', () => {
      if (this._paginationClick) {
        this._paginationClick = false;
        return;
      }

      requestAnimationFrame(() => {
        const index = this.embla.selectedScrollSnap();
        console.log('pointerUp Snap to', index);
        this.embla.scrollTo(index);
      });
    });
  }

  // END CALLBACK

  // --- FADE‑MODE SAFE THUMBNAIL SYNC (NO JUMP, NO DRIFT, NO MISSING SLIDES) ---
  setupThumbnails() {
    const thumbsSelector = this.dataset.sliderThumbs;
    if (!thumbsSelector) return;

    const thumbsRoot = document.querySelector(thumbsSelector);
    if (!thumbsRoot) return;

    // Thumbnails MUST snap for stable scrollTo
    const thumbsEmbla = EmblaCarousel(thumbsRoot, {
      align: 'start',
      containScroll: 'keepSnaps',
      dragFree: false,
      slides: '.bd-track > .slide',
    });

    const thumbSlides = thumbsEmbla.slideNodes();

    // --- INITIAL SYNC ---
    const initialSlide = parseInt(this.dataset.initialSlide);
    if (!isNaN(initialSlide)) {
      queueMicrotask(() => thumbsEmbla.scrollTo(initialSlide, true));
    }

    // --- CLICK → MAIN SLIDER ---
    thumbSlides.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        this.embla.scrollTo(index, true); // fade mode → instant index change
      });
    });

    // --- MAIN SLIDER → THUMBS ---
    const updateThumbs = () => {
      const selected = this.embla.selectedScrollSnap();

      // Highlight active thumb
      thumbSlides.forEach((thumb, index) => {
        thumb.classList.toggle('is-active', index === selected);
      });

      // Scroll thumbnails WITHOUT relying on main slider scroll model
      thumbsEmbla.scrollTo(selected, false);
    };

    this.embla.on('select', updateThumbs);
    updateThumbs();
  }

  // Step‑by‑step autoplay logic
  startAutoplay(autoplayMs) {
    const run = () => this.embla.scrollNext();

    // Clear any existing interval before starting a new one
    if (this.autoplayId) clearInterval(this.autoplayId);

    this.autoplayId = setInterval(run, autoplayMs);

    const stop = () => {
      clearInterval(this.autoplayId);
      this.autoplayId = null;
    };

    const resume = () => {
      if (!this.autoplayId) {
        this.autoplayId = setInterval(run, autoplayMs);
      }
    };

    // Remove old listeners before adding new ones
    this.slider.removeEventListener('mouseenter', stop);
    this.slider.removeEventListener('pointerdown', stop);
    this.slider.removeEventListener('mouseleave', resume);
    this.slider.removeEventListener('pointerup', resume);

    this.slider.addEventListener('mouseenter', stop);
    this.slider.addEventListener('pointerdown', stop);
    this.slider.addEventListener('mouseleave', resume);
    this.slider.addEventListener('pointerup', resume);
  }

  scrollTo(index) {
    this.embla?.scrollTo(index);
  }

  setupDots() {
    const showDots = this.dataset.dots === 'true';
    if (!showDots) return;

    let dotsContainer = this.querySelector('.slider-dots');
    if (!dotsContainer) {
      dotsContainer = document.createElement('div');
      dotsContainer.className = 'slider-dots';
      this.slider.after(dotsContainer);
    }

    const slides = this.embla.slideNodes();
    dotsContainer.innerHTML = '';

    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'slide-dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);

      dot.addEventListener('pointerdown', () => {
        this._paginationClick = true;
      });

      dot.addEventListener('click', () => {
        this.embla.scrollTo(index);
      });

      dotsContainer.appendChild(dot);
    });

    const updateDots = () => {
      const selected = this.embla.selectedScrollSnap();
      [...dotsContainer.children].forEach((dot, i) => {
        dot.classList.toggle('is-selected', i === selected);
      });
    };

    this.embla.on('select', updateDots);
    updateDots();
  }

  setupArrows() {
    const showArrows = this.dataset.arrows === 'true';
    if (!showArrows) return;

    // Allow override selectors
    const prevSelector = this.dataset.prevSelector || '[data-prev]';
    const nextSelector = this.dataset.nextSelector || '[data-next]';

    // Try to find user-provided arrows
    let prevBtn = this.querySelector(prevSelector);
    let nextBtn = this.querySelector(nextSelector);

    // If user did NOT provide arrows → generate defaults
    if (!prevBtn) {
      prevBtn = document.createElement('button');
      prevBtn.className = 'prev slide-arrow';
      prevBtn.setAttribute('data-prev', '');
      prevBtn.setAttribute('aria-label', 'Previous slide');
      prevBtn.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
        <path d="M12 15l-5-5 5-5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
      this.slider.prepend(prevBtn);
    }

    if (!nextBtn) {
      nextBtn = document.createElement('button');
      nextBtn.className = 'next slide-arrow';
      nextBtn.setAttribute('data-next', '');
      nextBtn.setAttribute('aria-label', 'Next slide');
      nextBtn.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true">
        <path d="M8 5l5 5-5 5" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
      this.slider.appendChild(nextBtn);
    }

    // Attach behavior
    prevBtn.addEventListener('pointerdown', () => {
      this._paginationClick = true;
    });
    nextBtn.addEventListener('pointerdown', () => {
      this._paginationClick = true;
    });

    prevBtn.addEventListener('click', () => {
      this.embla.scrollPrev();
    });
    nextBtn.addEventListener('click', () => {
      this.embla.scrollNext();
    });
  }

  updateControls() {
    if (!this.embla) return;

    const canScroll = this.embla.canScrollNext() || this.embla.canScrollPrev();

    const prev = this.querySelector('[data-prev]');
    const next = this.querySelector('[data-next]');
    const dots = this.querySelector('.slider-dots');

    if (prev) prev.style.display = canScroll ? 'flex' : 'none';
    if (next) next.style.display = canScroll ? 'flex' : 'none';
    if (dots) dots.style.display = canScroll ? 'flex' : 'none';
  }

  setupPrevNext() {
    const prevBtn = this.querySelector('[data-prev]');
    const nextBtn = this.querySelector('[data-next]');

    // Optional: disable buttons when you can’t scroll further (non-loop mode)
    const updateButtons = () => {
      if (prevBtn) prevBtn.disabled = !this.embla.canScrollPrev();
      if (nextBtn) nextBtn.disabled = !this.embla.canScrollNext();
    };

    this.embla.on('select', updateButtons);
    updateButtons();
  }

  // Custom pagination logic
  setupCustomPagination() {
    if (!this.slider.hasAttribute('data-custom-pag')) return;

    const customPrev = this.querySelector('.prev-arrow');
    const customNext = this.querySelector('.next-arrow');
    const customPrevText = this.querySelector('[data-prev-text]');
    const customNextText = this.querySelector('[data-next-text]');

    const updatePagNames = () => {
      const slides = this.embla.slideNodes();
      const currentIndex = this.embla.selectedScrollSnap();
      const nextIndex = (currentIndex + 1) % slides.length;
      const prevIndex = (currentIndex - 1 + slides.length) % slides.length;

      customNextText.textContent = slides[nextIndex]?.dataset.title || '';
      customPrevText.textContent = slides[prevIndex]?.dataset.title || '';
    };

    this.embla.on('select', () => {
      const slides = this.embla.slideNodes();
      updatePagNames();
      slides.forEach((slide, index) => {
        slide.setAttribute(
          'aria-hidden',
          index === this.embla.selectedScrollSnap() ? 'false' : 'true',
        );
        slide.setAttribute(
          'tabindex',
          index === this.embla.selectedScrollSnap() ? '0' : '-1',
        );
      });
    });

    customPrev?.addEventListener('click', () => this.embla.scrollPrev());
    customNext?.addEventListener('click', () => this.embla.scrollNext());

    updatePagNames();
  }

  isDisabledForViewport(disableSetting) {
    const width = window.innerWidth;

    switch (disableSetting) {
      case 'mobile':
        return width < 749;
      case 'tablet':
        return width >= 749 && width < 1024;
      case 'desktop':
        return width >= 1024;
      case 'tablet-up':
        return width >= 768;
      case 'mobile-only':
        return width < 480;
      default:
        return false;
    }
  }

  handleResize() {
    clearTimeout(this._resizeTimeout);
    this._resizeTimeout = setTimeout(() => {
      const disableSetting = this.slider?.dataset.sliderDisable;
      const shouldDisable =
        disableSetting && this.isDisabledForViewport(disableSetting);

      // Always destroy first
      this.destroySlider();

      // Re-init only if allowed
      if (!shouldDisable) {
        this.initSlider();
      }
    }, 150);
  }

  destroySlider() {
    // Stop autoplay interval
    if (this.autoplayId) {
      clearInterval(this.autoplayId);
      this.autoplayId = null;
    }

    // Destroy Embla
    if (this.embla) {
      this.embla.destroy();
      this.embla = null;
    }

    // Remove dots container so it can be rebuilt correctly
    const dots = this.querySelector('.slider-dots');
    dots?.remove();

    const prev = this.querySelector('[data-prev]');
    const next = this.querySelector('[data-next]');
    prev?.remove();
    next?.remove();
    this.slider?.removeEventListener('wheel', this.handleWheel);
  }

  markEdgeProximity() {
    if (!this.embla) return;

    const viewport = this.slider;
    const viewportRect = viewport.getBoundingClientRect();
    const slides = this.embla.slideNodes();

    slides.forEach((slide, index) => {
      slide.classList.remove(
        'near-left-edge',
        'near-right-edge',
        'extreme-left-edge',
        'extreme-right-edge',
      );

      const rect = slide.getBoundingClientRect();
      const slideCenter = rect.left + rect.width / 2;

      // Detect popup width dynamically
      const popup = slide.querySelector('.bd-slide-card');
      const popupWidth = popup ? popup.offsetWidth : 300;

      const nearThreshold = popupWidth / 2; // mild shift
      const extremeThreshold = popupWidth / 4; // strong shift

      const distanceLeft = slideCenter - viewportRect.left;
      const distanceRight = viewportRect.right - slideCenter;

      // EXTREME EDGE
      if (distanceLeft < extremeThreshold) {
        slide.classList.add('extreme-left-edge');
        //  console.log(`[EDGE] Slide ${index} EXTREME LEFT (${distanceLeft}px)`);
        return;
      }
      if (distanceRight < extremeThreshold) {
        slide.classList.add('extreme-right-edge');
        // console.log(`[EDGE] Slide ${index} EXTREME RIGHT (${distanceRight}px)`);
        return;
      }

      // NORMAL EDGE
      if (distanceLeft < nearThreshold) {
        slide.classList.add('near-left-edge');
        //console.log(`[EDGE] Slide ${index} near LEFT (${distanceLeft}px)`);
        return;
      }
      if (distanceRight < nearThreshold) {
        slide.classList.add('near-right-edge');
        //console.log(`[EDGE] Slide ${index} near RIGHT (${distanceRight}px)`);
        return;
      }

      // console.log(`[EDGE] Slide ${index} centered`);
    });
  }
  hasUnderflow() {
    const track = this.slider.querySelector('.bd-track');
    if (!track) return false;

    const viewportWidth = this.slider.offsetWidth;
    const trackWidth = track.scrollWidth;

    return trackWidth <= viewportWidth;
  }
 handleWheel(e) {
  if (!this.embla) return;

  const { deltaX } = e;

  // Only act on real horizontal wheel movement
  if (Math.abs(deltaX) < 2) return; // threshold avoids noise

  // If track doesn't overflow, bail
  if (!this.embla.canScrollNext() && !this.embla.canScrollPrev()) return;

  // Prevent page from horizontal drifting
  e.preventDefault();

  if (deltaX > 0) {
    this.embla.scrollNext();
  } else {
    this.embla.scrollPrev();
  }
}


}

customElements.define('bd-slider', bdSlider);
